import Vue from 'vue'
import moment from 'moment'


const filters = () => {
    Vue.filter('capitalize', (value) => {
        if (value && typeof value === 'string') {
            return value.charAt(0).toUpperCase() + value.slice(1)
        }

        return ''
    })

    Vue.filter('formatDate_', function(value) {
        if (value) {
            return moment(String(value)).format('MM/DD/YYYY')
        }
    });


    Vue.filter('formatDate', (value, formatType = 'LL') => {
        if (!value) return ''
        return moment(value).format(formatType)
    })

    Vue.filter('formatDateTime', function(value) {
        if (value) {
            return moment(String(value)).format('LLL')
        }
    });

    Vue.filter('formatDateShort', (value, formatType = 'L') => {
        if (!value) return ''
        return moment(value).format(formatType)
    })


    Vue.filter('fromNow', (value) => {
        if (!value) return ''
        return moment(value).fromNow()
    })

    var filter = function(text, length, clamp){
        clamp = clamp || '...';
        var node = document.createElement('div');
        node.innerHTML = text;
        var content = node.textContent;
        return content.length > length ? content.slice(0, length) + clamp : content;
    };
    
    Vue.filter('truncate', filter);
}

export default filters